import { render, staticRenderFns } from "./MspForsageOrderDetail.vue?vue&type=template&id=6501e33a"
import script from "./MspForsageOrderDetail.vue?vue&type=script&lang=js"
export * from "./MspForsageOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./MspForsageOrderDetail.vue?vue&type=style&index=0&id=6501e33a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports